// polyfills
import "core-js/stable"; // both should be over everything because polyfills
import "regenerator-runtime/runtime"; // both should be over everything because polyfills
import "./types/Extensions"; // should be higher than store since it uses extensions
import "document-register-element/build/document-register-element"; // should be over custom element stuff
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import vuetify from "./vuetify";
// import "@mdi/font/scss/materialdesignicons.scss";
import '@mdi/font/scss/materialdesignicons.scss';
import "./scss/style.scss";
import "./plugins/components";
import axios from "axios";
import { serviceOptions } from "./services/index.defs";
serviceOptions.axios = axios.create();

import resizer from "iframe-resizer/js/iframeResizer.contentWindow";

Vue.config.productionTip = false;
resizer.onReady = () => {};
new Vue({
    vuetify,
    router,
    store: store.original,
    render: (h) => h(App),
    methods: {
        scrollUp() {
            setTimeout(() => {
                document.getElementById("app").scrollIntoView({ block: "start", behavior: "smooth" });
                window.parent.postMessage("scrollUp", "*");
            }, 0);
        },
    },
}).$mount("#app");

const allowedHosts = [
    'pampadu.ru',
    'pamstage1.ru',
    'pamstage2.ru',
    'pamcpa1.ru',
    'pamtest1.ru',
    'pamtest2.ru',
    'ppdu.ru',
    'pamload1.ru'
],
    locationHasTarget = (target: string) => location.origin.includes(target),
    isDev = process.env.NODE_ENV == "development";
//@ts-ignore
// needed for otp bank to have ability to load resources locally
// обязательно выпилить после того как интеграция с отп станет неактуальной
if (!isDev && !allowedHosts.some(locationHasTarget)) __webpack_public_path__ = "https://b2c.pampadu.ru/";
